"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionMoreActions_1 = require("../../../../../../shared/components/table_actions/TableActionMoreActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionUser_1 = require("../../../../../../shared/components/table_actions/TableActionUser");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var UsrAdminsList = /** @class */ (function (_super) {
    __extends(UsrAdminsList, _super);
    function UsrAdminsList(props) {
        var _this = _super.call(this, props) || this;
        _this.action_more_get_pass = "action:get_password";
        _this.action_more_set_pass = "action:set_password";
        _this.columns = [
            {
                title: 'Логин пользователя',
                dataIndex: _this.props.data.dk_login,
                key: _this.props.data.dk_login,
                width: 250,
            }, {
                title: 'Изменен',
                dataIndex: _this.props.data.dk_date_changed2,
                key: _this.props.data.dk_date_changed2,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_changed2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Заблокирован',
                dataIndex: _this.props.data.dk_is_locked,
                key: _this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать администратора", text: "Да" }, unlockedTexts: { menu: "Разблокировать администратора", text: "Нет" }, record: { key: record.key, title: record.login, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 150,
            }, {
                title: 'Мультидоступ',
                dataIndex: _this.props.data.dk_is_multiaccess,
                key: _this.props.data.dk_is_multiaccess,
                align: "center",
                render: function (text, record, idx) {
                    if (record.is_multiaccess) {
                        return (React.createElement("div", null, "\u0414\u0410"));
                    }
                    else {
                        return (React.createElement("div", null, "\u041D\u0415\u0422"));
                    }
                },
                width: 150,
            }, {
                title: 'Доступно брендов',
                dataIndex: _this.props.data.dk_allowed_brands_count,
                key: _this.props.data.dk_allowed_brands_count,
                width: 200,
                align: "center",
            }, {
                title: 'Привилегии пользователя',
                dataIndex: _this.props.data.dk_permission_title,
                key: _this.props.data.dk_permission_title,
                width: 200,
                render: function (text, record, index) {
                    return (React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "user-shield" }),
                        " ",
                        record.permission_title,
                        " "));
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionUser_1.default, { disabled: record.usr_level <= 0, hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F", onClick: function () { _this.onAccessClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteAdminClick(record); } }),
                    React.createElement(TableActionMoreActions_1.default, { hint: "\u0415\u0449\u0435", menu: _this.getMoreActionsDropDownMenu(record) }))); },
                width: 130
            }
        ];
        return _this;
    }
    UsrAdminsList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    UsrAdminsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0
        }, function () {
            _this.props.data.LoadData(function () {
                _this.props.data.LoadAvailPermissions();
            });
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    UsrAdminsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    UsrAdminsList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData();
            });
        }
    };
    UsrAdminsList.prototype.doMorection = function (e, record) {
        var _this = this;
        if (e.key == this.action_more_get_pass) {
            this.props.data.GetAdminPassword(record.key, function (pass) {
                _this.props.dlgView.SetTitle("\u041F\u0430\u0440\u043E\u043B\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F : " + record.login + " ").SetText(pass).Show();
            });
        }
        if (e.key == this.action_more_set_pass) {
            this.props.dlgPwd.clearFields().SetOnYesClick(function (newpass) {
                _this.props.data.SetAdminNewPassword(record.key, newpass, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u041F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 ",
                        React.createElement("b", null,
                            "[",
                            record.login,
                            "]"),
                        " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
                });
            }).Show();
        }
    };
    UsrAdminsList.prototype.getMoreActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doMorection(e, record); } },
            React.createElement(antd_1.Menu.Item, { key: this.action_more_get_pass },
                React.createElement(FontAwesome_1.FA, { icon: "eye", left: true }),
                "\u0423\u0437\u043D\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_set_pass },
                React.createElement(FontAwesome_1.FA, { icon: "key", left: true }),
                "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C")));
    };
    UsrAdminsList.prototype.doLockUnLockAction = function (Key, Login, Lock) {
        this.props.data.SetAdminIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Login,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Login,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    UsrAdminsList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record.key);
        }
    };
    UsrAdminsList.prototype.onAccessClick = function (record) {
        if (this.props.onAccessClick) {
            this.props.onAccessClick(record.key);
        }
    };
    UsrAdminsList.prototype.onDeleteAdminClick = function (record) {
        this.props.data.DeleteAdmin(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 ",
                React.createElement("b", null,
                    "[",
                    record.login,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    UsrAdminsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    UsrAdminsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData();
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    UsrAdminsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added2.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u043C\u044F:"),
                            " [",
                            record.name,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "email:"),
                            " [",
                            record.email,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0442\u0435\u043B\u0435\u0444\u043E\u043D:"),
                            " [",
                            record.phone,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0441\u043A\u0430\u0439\u043F:"),
                            " [",
                            record.skype,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0443\u0440\u043E\u0432\u0435\u043D\u044C:"),
                            " [",
                            record.usr_level,
                            "]")));
                }, scroll: { x: true } })));
    };
    return UsrAdminsList;
}(React.Component));
exports.default = UsrAdminsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/usr_admins_list/ui/component/UsrAdminsList.tsx
// module id = 1892
// module chunks = 0